export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-8cd45d88',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
